/**
 * Created by Bob.Bao on 2018/1/15.
 */
export default {
    stockName(supplierStockList) {
        return supplierStockList.map(supplier => {
            return supplier.fnameL2
        }).join(',')
    },
    date(timeStr, format, divider) {
        if (!timeStr) {
            return ''
        }
        divider = divider || '-';
        let t = getDateArray(timeStr);
        switch (format) {
            case 'date':
                return t[2];
            case 'month':
                return t[1];
            case 'year':
                return t[0];
            case 'yymm':
                return [t[0], t[1]].join(divider);
            case 'ymdhm':
                return [
                    [t[0], t[1], t[2]].join(divider), [t[3], t[4]].join(':')
                ].join(' ');
            default:
                return [t[0], t[1], t[2]].join(divider);
        }

        function getDateArray(date) {
            try {
                if (typeof date == 'string') {
                    date = date.slice(0, 19).replace(/\-/g, '/')
                }
                var d = new Date(date);
                return [d.getFullYear(), d.getMonth() + 1, d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds()].map(v => {
                    if (v > 9) {
                        return '' + v;
                    } else {
                        return '0' + v;
                    }
                })
            } catch (e) {
                return ['', '', '', '', '', ''];
            }
        }
    },
    currency(value, places, symbol) {
        places = isNaN(places) ? 0 : places;
        symbol = symbol || '￥'
        return value != null ? formatMoney(value, places, symbol) : ''

        function formatMoney(number, places, symbol, thousand, decimal) {
            places = !isNaN(places = Math.abs(places)) ? places : 2;
            symbol = symbol !== undefined ? symbol : "$";
            thousand = thousand || ",";
            decimal = decimal || ".";
            var negative = number < 0 ? "-" : "",
                i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + "",
                j = i.length;
            j = j > 3 ? j % 3 : 0;
            return symbol + ' ' + negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : "");
        }
    }
}



// WEBPACK FOOTER //
// ./src/filter/index.js